// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + {"131":"780f18d9e5159bf9c6f9","781":"e11914e0350ad4dc660e"}[chunkId] + ".css";
};